import { render } from "./CheckoutTransaction.vue?vue&type=template&id=b9e426b2&scoped=true"
import script from "./CheckoutTransaction.vue?vue&type=script&lang=js"
export * from "./CheckoutTransaction.vue?vue&type=script&lang=js"

import "./CheckoutTransaction.vue?vue&type=style&index=0&id=b9e426b2&scoped=true&lang=css"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e426b2"]])

export default __exports__